import ServerBase from '@/sdk/server/server_base';
import {ServerConfig} from '@/config/routers';

class KuShareServer extends ServerBase {
    serverUrl: string = ServerConfig.kuShare;

    constructor() {
        super('wikiToken');
    }

    async checkMembers(data: any) {
        const result = await this.request({
            method: 'post',
            url: `${this.serverUrl}/api/mGetDocPermission`,
            data: data,
        });
        console.log('kuShare日志：kuShare checkMembers--------------');
        return result;
    }

    async addMembers(data: any) {
        const result = await this.request({
            method: 'post',
            url: `${this.serverUrl}/api/addRlMember`,
            data: data,
        });
        console.log('kuShare日志：kuShare addMembers--------------');
        return result;
    }

    async getDocInfo(data: any) {
        const result = await this.request({
            method: 'post',
            url: `${ServerConfig.ku}/kuShare/api/mGetDocInfo`,
            data: data,
        });
        return result;
    }

    // 添加小红点通知记录
    async addNotifyRecord(data: any) {
        const result = await this.request({
            method: 'post',
            url: `${this.serverUrl}/broadcast/addChatRecord`,
            data: data,
        });
        console.log('kuShare日志：kuShare addChatRecord--------------');
        return result;
    }
}

export default KuShareServer;
